
import {HttpClient, HttpParams} from "@angular/common/http";
import {environment} from "../../../../environments/environment";
import {Injectable} from "@angular/core";
import {map, Observable} from "rxjs";



@Injectable({
  providedIn: 'root'
})
export class SpeakerService {
  baseURL = environment.baseUrl + 'speaker';

  constructor(private http: HttpClient) {
  }

  getSpeakerList(eventId:any){
    return this.http.get<any>(`${this.baseURL}/event/${eventId}`)
  }


  saveSpeaker(eventId:any,formData:FormData){
    return this.http.post<any>(`${this.baseURL}/save/event/${eventId}`,formData).pipe(
      map((res: any) => {
        return res;
      })
    );
  }

  updateSpeaker(eventId:any,formData:FormData,speakerId:any){
    return this.http.put<any>(`${this.baseURL}/update/event/${eventId}/speaker/${speakerId}`,formData).pipe(
      map((res: any) => {
        return res;
      })
    );
  }

  deleteSpeaker(eventId:any,speakerId:any){
    return this.http.delete<any>(`${this.baseURL}/event/${eventId}`,{
      params:new HttpParams()
        .append('speakerId',speakerId)
    })
  }

  updateOrder(eventId:any,speakerList:any):Observable<any>{
    return this.http.put<any>(`${this.baseURL}/event/${eventId}`,speakerList)
  }
}
